import * as React from "react";
import { EventEmmiter } from "src/utils/events.js";
import {
  Block,
  Page,
  Navbar,
  Link,
  Popup,
  NavRight,
  Row,
  Card,
  CardContent,
  CardHeader,
  Col,
  List,
  BlockTitle,
  ListItem,
  Button,
} from "framework7-react";
import { api, CONSTRUCTION } from "src/utils/utils";
import { SCAN_PRODUCTS } from "../../utils/utils";
import {
  API_URL,
  CLOUD_FUNCTION,
  GET_FILTER,
  POST_FILTER,
} from "src/utils/constants";

export default class ProductsCompetitors extends React.Component {
  public extractPageProduct = 1;
  public currentLink: any = "";

  public item: any;

  public state = {
    link: "",
    competitor: {} as any,
    book: [] as any,
    productsInfo: {
      pageCount: 0,
      quantity: 0,
      pages: [] as any[],
    },
  };

  public book = [] as any[];

  constructor(props: {} | Readonly<{}>) {
    super(props);
    this.reset();
  }

  public componentDidMount() {
    EventEmmiter.subscribe(
      "hook-competitors-popup",
      async (competitor: any) => {
        const dialog = this.$f7?.dialog.preloader("Cargando Productos");
        dialog?.open();
        const filter = {
          table: "products",
          where: {
            id_competitor: competitor.id,
            status: 1,
          },
          order: "name asc",
        };
        this.book = await api.get<any[]>(
          API_URL + GET_FILTER + encodeURIComponent(JSON.stringify(filter)),
          {}
        );
        console.log("this.book", this.book);

        this.setState({
          competitor,
          book: this.book,
        });
        dialog?.close();
        this.extractPageProduct = 1;
        this.currentLink = "";
      }
    );

    EventEmmiter.subscribe("category_box_selected", async (data: any) => {
      this.item.category_box = data.caja.name;
      this.item.internal_id = data.item[0];

      const dialog = this.$f7?.dialog.preloader("Guardando");
      dialog?.open();
      const updated = (await api.post(
        API_URL +
          POST_FILTER +
          encodeURIComponent(JSON.stringify({ table: "products" })),
        this.item
      )) as any;

      console.log("updated row", updated);

      this.setState({
        book: this.state.book,
      });
      dialog?.close();
    });
  }

  public reset = () => {
    this.setState({
      link: "",
      competitor: {},
    });
  };

  public openProductsCompete(item: any) {
    console.log(item);
    this.item = item;
    EventEmmiter.dispatch("select_category_box", item);
  }

  public saveProducts(): void {
    CONSTRUCTION(this);
  }

  public async scanProducts() {
    if (this.currentLink === "") {
      this.book = [];
      this.currentLink = this.state.competitor.linkPublications;
    }

    if (this.extractPageProduct === 51) {
      this.currentLink = this.currentLink.replace(
        "_CustId_",
        "_Desde_" + this.extractPageProduct + "_CustId_"
      );
    } else if (this.extractPageProduct > 51) {
      this.currentLink = this.currentLink.replace(
        "_" + (this.extractPageProduct - 50) + "_",
        "_" + this.extractPageProduct + "_"
      );
    }

    console.log("this.currentLink", this.currentLink);
    const dialog = this.$f7?.dialog.preloader(
      "Extrayendo datos de Mercado Libre. " + this.extractPageProduct
    );
    dialog?.open();

    const book = await SCAN_PRODUCTS(
      this.currentLink,
      this.state.competitor.id
    );

    // console.log("book", JSON.parse(book[0].data));
    book.map((row: any) => {
      this.book.push(row);
    });
    console.log("this.book", this.book);

    // SAVE IN SERVER
    const inserted = (await api.post(API_URL + CLOUD_FUNCTION + "saveBook", {
      book,
    })) as any;
    console.log("inserted", inserted);

    this.extractPageProduct += 50;
    if (book.length) {
      const rndTime = Math.random() * (1 - 0.1 + 1) + 0.1;
      setTimeout(() => {
        dialog?.close();
        this.scanProducts();
      }, rndTime);
    } else {
      dialog?.close();

      EventEmmiter.dispatch("hook-competitors-popup", this.state.competitor);

      this.$f7?.toast
        .create({
          text: "Productos guardados con éxito",
          position: "center",
          closeTimeout: 2000,
        })
        .open();
    }
  }

  public render() {
    return (
      <Popup
        className="products-competitors-popup"
        closeByBackdropClick={false}
      >
        <Page>
          <Navbar title={"Productos de " + this.state.competitor.storeName}>
            <NavRight>
              <Link className="closeOrder" popupClose>
                <i className="icon icon-x" />
              </Link>
            </NavRight>
          </Navbar>

          {this.state.book.length ? (
            <Block>
              <Card outline={true}>
                <CardHeader>
                  <div className="fb">Publicaciones del Vendedor</div>
                </CardHeader>
                <CardContent padding={false}>
                  <Row>
                    <Col width="100">
                      <List mediaList>
                        <ListItem
                          header="No. de productos:"
                          text=""
                          subtitle={this.state.book.length + " resultados"}
                        />
                      </List>
                    </Col>
                  </Row>
                </CardContent>
              </Card>
              <BlockTitle>Lista de productos</BlockTitle>
              <Card outline={true}>
                <List mediaList>
                  {this.state.book
                    .sort((a: any, b: any) => a.name - b.name)
                    .map((product: any) => {
                      const data = JSON.parse(product.data);
                      return (
                        <ListItem
                          className="customProductRow"
                          link="#"
                          key={product.id}
                          title={product.name}
                          after={"$" + product.price}
                          subtitle={"Inventario: " + product.inventory}
                          text={
                            "COMPITIENDO EN: " +
                            product.internal_id +
                            " " +
                            product.category_box
                          }
                        >
                          <img
                            slot="media"
                            src={data.pictures.stack.retina}
                            width="80"
                          />
                          <div className="fb tag-item">
                            {product.category.split("_").join(" ")}
                          </div>
                          <Link
                            target={"_blank"}
                            external
                            href={data.permalink}
                          >
                            Ver en MercadoLibre
                          </Link>
                          <Button
                            fill
                            color="yellow"
                            className="font__5"
                            raised
                            onClick={(e: any) => {
                              console.log("product", product);

                              this.openProductsCompete(product);
                            }}
                          >
                            {product.internal_id === null
                              ? "Poner a competir"
                              : "Editar"}
                          </Button>
                        </ListItem>
                      );
                    })}
                </List>
              </Card>
            </Block>
          ) : (
            <Block>
              <BlockTitle>Aun no se han escaneado los productos.</BlockTitle>
            </Block>
          )}

          <Block strong className={"bg-white"}>
            <Row tag="p">
              {/* <Button popupClose className="col">
                  <div className="fb">Cancelar</div>
                </Button> */}

              {!this.state.book.length ? (
                <button
                  className="col customButton_1 fb button button-fill"
                  onClick={(e: any) => this.scanProducts()}
                >
                  Escanear Productos
                </button>
              ) : (
                <button
                  onClick={(e: any) => this.saveProducts()}
                  className="col customButton_1 fb button button-fill"
                >
                  Reescanear Productos
                </button>
              )}
            </Row>
          </Block>
        </Page>
      </Popup>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/prefabs/ProductsCompetitors.tsx